import { render, staticRenderFns } from "./CallFamilyModal.vue?vue&type=template&id=2749cc56&scoped=true&"
import script from "./CallFamilyModal.vue?vue&type=script&lang=ts&"
export * from "./CallFamilyModal.vue?vue&type=script&lang=ts&"
import style0 from "./CallFamilyModal.vue?vue&type=style&index=0&id=2749cc56&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2749cc56",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCardActions,VCardText,VCardTitle,VCol,VRow,VSpacer})
